import { gql } from "@apollo/client";

export const GET_PAYMENT_FORM_DATA_DESCRIPTION = gql`
  query getPaymentFormDataDescription($input: GetPaymentFormDataInput!) {
    getPaymentFormData(input: $input) {
      description
    }
  }
`;
